// Generatore di colori distinti e deterministici.
// Non usa una palette fissa: a partire da un indice incrementale auto-genera una
// tinta ruotando l'angolo aureo sulla ruota dei colori (HSL), così indici
// consecutivi producono sempre colori ben distinguibili.

const GOLDEN_ANGLE = 137.508;

function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n) => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0");
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}

/**
 * Genera un colore esadecimale distinto a partire da un indice incrementale.
 * @param {number} index indice incrementale (0, 1, 2, ...)
 * @param {{saturation?: number, lightness?: number}} [options]
 * @returns {string} colore in formato `#rrggbb`
 */
export function generateDistinctColor(index, { saturation = 72, lightness = 45 } = {}) {
    const hue = (index * GOLDEN_ANGLE) % 360;
    return hslToHex(hue, saturation, lightness);
}
